// assign/vm-form
import { useLoadingAction } from 'src/hooks/use-actions';
import { apiAccountToGroup, apiCarToAccount, apiCarToGroup } from './data';

const useForms = () => {
  const accountToGroup = (payload, onSuccess, onError) =>
      useLoadingAction(apiAccountToGroup, payload, onSuccess, onError);

  const carToAccount = (payload, onSuccess, onError) =>
      useLoadingAction(apiCarToAccount, payload, onSuccess, onError);

  const carToGroup = (payload, onSuccess, onError) =>
      useLoadingAction(apiCarToGroup, payload, onSuccess, onError);

  return {
    accountToGroup,
    carToAccount,
    carToGroup,
  };
};


export default useForms;
